var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"AccountRecCatalogs"}},[_c('Page',{attrs:{"title":_vm.$t('Recommendations.catalogs'),"size":"fullWidth"}},[_c('Card',[_c('DataTable',{attrs:{"columns":[
          {
            key: 'id',
            label: _vm.$t('ID')
          },
          {
            key: 'name',
            label: _vm.$t('Name')
          },
          {
            key: 'domain',
            label: _vm.$t('Domain')
          },
          {
            key: 'languageCode',
            label: _vm.$t('Language')
          },
          {
            key: 'currencyCode',
            label: _vm.$t('Currency')
          },
          {
            key: 'uniqueItemsFp',
            label: _vm.$t('Recommendations.totalItems'),
            format: 'integer'
          }
        ],"rows":_vm.catalogs,"row-actions":function (row) { return [
          {
            label: _vm.$t('Recommendations.viewImports'),
            onAction: function () { return _vm.$router.push({name: 'AccountRecCatalogImports', params:{catalogId: row.id}}); }
          }
        ]; },"loading":_vm.isLoading}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }